import React, { Component } from 'react'
import Splash from 'App/Splash'
import { withLastLocation } from 'react-router-last-location'
import userManager from 'Auth/Zendesk/userManager'

import PropTypes from 'prop-types'
class Login extends Component {
  constructor (parentContext) {
    super()
    this.props = parentContext
    this.state = {
      redirect: ''
    }
  }
  componentDidMount () {
    var queryString = require('query-string')
    // eslint-disable-next-line camelcase
    const { return_to } = queryString.parse(this.props.location.search)
    userManager.signinRedirect({ state: return_to })
  }

  render () {
    return <Splash text='Redirecionando para o login' />
  }
}

Login.propTypes = {
  location: PropTypes.string
}

export default withLastLocation(Login)



// WEBPACK FOOTER //
// ./src/Auth/Zendesk/Login.js